<template>
  <v-dialog
    :model-value="isOpen"
    :theme="dialogTheme"
    width="100%"
    :max-width="maxWidth"
    @update:model-value="setOpen"
  >
    <v-card
      color="default-panel"
      class="base-dialog-prompt-card text-default-content pb-3"
      rounded="sm"
    >
      <v-card-title style="word-break: normal;">
        <slot name="title"></slot>
      </v-card-title>
      <v-card-subtitle v-if="hasSubtitle">
        <slot name="subtitle"></slot>
      </v-card-subtitle>
      <div v-if="hasContent">
        <slot name="content"></slot>
      </div>
      <v-card-actions class="base-dialog-prompt-actions">
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'BaseDialogPrompt',

  inheritAttrs: false,

  props: {
    modelValue: {},
    value: {},
    maxWidth: {
      type: String,
      default: '500px',
    },
  },

  emits: ['update:modelValue', 'input'],

  computed: {
    isOpen() {
      return !!(this.modelValue ?? this.value);
    },

    dialogTheme() {
      return this.$store.state.isDarkMode ? 'dark' : 'light';
    },

    hasSubtitle() {
      return (this.$slots.subtitle?.().length ?? 0) > 0;
    },

    hasContent() {
      return (this.$slots.content?.().length ?? 0) > 0;
    },
  },

  methods: {
    setOpen(open) {
      const value = open ? (this.modelValue ?? this.value ?? true) : false;
      this.$emit('update:modelValue', value);
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped>
.base-dialog-prompt-card :deep(.v-card-title) {
  padding: 16px 16px 8px;
  font-size: 1.25rem;
  font-weight: 500;
  line-height: 1.75rem;
  white-space: normal;
}

.base-dialog-prompt-actions {
  min-height: 52px;
  padding: 8px 16px;
  gap: 0;
}
</style>
